import { LinkProps, PaletteOptions, colors, createTheme } from '@mui/material';
import { A11yLink } from '../../routing/A11yLink';
import { palette } from './theme';

export const navBarTheme = (themeMode: 'light' | 'dark') =>
  createTheme({
    components: {
      // Configure links and buttons to use `react-router-dom`
      // See https://v5.mui.com/material-ui/integrations/routing/#global-theme-link
      MuiLink: { defaultProps: { underline: 'none', component: A11yLink } as LinkProps },
      MuiButtonBase: { defaultProps: { LinkComponent: A11yLink } },
      MuiTabs: {
        styleOverrides: {
          root: {
            '& .MuiTabs-indicator': {
              backgroundColor: themeMode === 'light' ? palette.primary.main : palette.primary.light,
            },
            '& .MuiTab-root': {
              color: themeMode === 'light' ? colors.grey[700] : colors.grey[400],
              '&.Mui-selected': {
                color: themeMode === 'light' ? palette.primary.main : palette.primary.light,
              },
              '&:not(.Mui-selected):hover': {
                color: themeMode === 'light' ? colors.grey[800] : colors.grey[300],
              },
            },
          },
        },
      },
      MuiTooltip: { styleOverrides: { tooltip: { fontSize: '0.875rem' } } },
    },
    palette: { mode: themeMode } as PaletteOptions,
  });

export const NAVBAR_DARK_THEME = navBarTheme('dark');
export const NAVBAR_LIGHT_THEME = navBarTheme('light');
